'use strict';

require('views/Signup/Signup.scss');

const React = require('react/addons'),
    Router = require('react-router'),
    _ = require('lodash'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    {Link} = Router,
    Uploader = require('components/Commons/Uploader/Uploader'),
    ComponentUtils = require('utils/ComponentUtils'),
    {toLower, trim} = require('lodash/string'),
    signUpService = require('services/SignUpServiceImpl').signUpService,
    ERROR_CODE_APPLICANT_ALREADY_EXIST = require('constants/AppConstants').ERROR_CODE_APPLICANT_ALREADY_EXIST,
    REGEX_NAME_SIGNUP = require('constants/AppConstants').REGEX_NAME_SIGNUP,
    ERROR_CODE_EMAIL_ALREADY_EXIST = require('constants/AppConstants').ERROR_CODE_EMAIL_ALREADY_EXIST,
    ERROR_CODE_USERNAME_ALREADY_EXIST = require('constants/AppConstants').ERROR_CODE_USERNAME_ALREADY_EXIST,
    ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST = require('constants/AppConstants').ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST,
    REGEX_EMAIL = require('constants/AppConstants').REGEX_EMAIL,
    WHERE_KNOW_US = require('constants/AppConstants').WHERE_KNOW_US,
    mui = require('material-ui'),
    PositionUtil = require('utils/PositionUtils'),
    ContentUtils = require('utils/ContentUtils'),
    {TextField, RaisedButton, DropDownMenu} = mui,
    {Navigation} = require('react-router');

const Signup = React.createClass({displayName: "Signup",

    mixins: [Navigation],

    contextTypes: {
        router: React.PropTypes.func
    },

    getInitialState() {
        return this._getEmptyModelForm('');
    },

    handleSubmit(event) {
        event.preventDefault();

        if (this.isValidForm(true)) {
            const signUp = {
                applicant: trim(this.refs.applicant.getValue()),
                username: trim(this.refs.username.getValue()),
                password: this.refs.password.getValue(),
                email: toLower(this.refs.email.getValue()),
                // guestUsername: trim(this.refs.guestUsername.getValue()),
                // guestPassword: this.refs.guestPassword.getValue(),
                // applicantLogoSrc: this.refs.applicantLogo.getValue(),
                applicantConfigurationDetail: SessionStore.getInferredUserInformation(),
                // whereKnowUsDetail: this.refs.whereKnowUsDetail.getValue(),
                // whereKnowUs: this._getCurrentWhereKnowUs().source
            };
            signUpService.signUp(signUp, this._onSuccess, this._onFailure);
        }
    },

    _getCurrentWhereKnowUs() {
        return WHERE_KNOW_US.find(type => type.name === this.refs.whereKnowUs.getInputNode().value) || {source: 'NOT_ANSWERED'};
    },

    _onSuccess: function () {
        this.setState({
            successfulSignup: true
        });
        setTimeout(() => {
            this.transitionTo(
                '/dashboard',
                {},
                {
                    email: this.refs.email.getValue()
                }
            );
        }, 1000);
    },

    _onFailure(message) {
        this.setState({
            error: true,
            errorApplicantName: message.message.indexOf(ERROR_CODE_APPLICANT_ALREADY_EXIST) > -1 ? t('sign_up_error_applicant_already_exist') : '',
            errorEmail: message.message.indexOf(ERROR_CODE_EMAIL_ALREADY_EXIST) > -1 ? t('sign_up_error_email_already_exist') : '',
            errorUsername: message.message.indexOf(ERROR_CODE_USERNAME_ALREADY_EXIST) > -1 ? t('sign_up_error_username_already_exist') : '',
            errorUsernameGuest: message.message.indexOf(ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST) > -1 ? t('sign_up_error_username_guest_already_exist') : ''
        });
    },

    isValidForm(onSubmit) {
        return true;
    },

    // isValidForm(onSubmit) {
    //     let messagesError = this._getEmptyModelForm(null),
    //         isValid = true,
    //         isFocusAssigned = false;

    //     const {
    //         isPristineApplicantName,
    //         isPristineEmail,
    //         isPristineUsername,
    //         isPristinePasswordAdmin,
    //         isPristineUsernameGuest,
    //         isPristinePasswordGuest
    //     } = this.state;

    //     isValid = isPristineApplicantName && isPristineEmail && isPristineUsername && isPristinePasswordAdmin && isPristineUsernameGuest && isPristinePasswordGuest;

    //     if (!isPristineApplicantName || onSubmit) {
    //         if (ContentUtils.isEmptyField(this.refs.applicant)) {
    //             messagesError.errorApplicantName = 'The Brewery is required';
    //             isValid = false;
    //         } else if (!REGEX_NAME_DEFAULT.test(this.refs.applicant.getValue())) {
    //             messagesError.errorApplicantName = 'Special characters not allowed';
    //             isValid = false;
    //         } else if (this.refs.applicant.getValue().length < 3) {
    //             messagesError.errorApplicantName = 'The Brewery name is too small';
    //             isValid = false;
    //         } else if (this.refs.applicant.getValue().length > 90) {
    //             messagesError.errorApplicantName = 'The Brewery name is too long';
    //             isValid = false;
    //         }

    //         if (!isValid) {
    //             isFocusAssigned = true;
    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.applicant.getDOMNode());
    //             PositionUtil.scrollTo(scrollTop);
    //         }
    //     }


    //     if (!isPristineUsername || onSubmit) {
    //         if (ContentUtils.isEmptyField(this.refs.username)) {
    //             messagesError.errorUsername = 'The username is required';
    //             isValid = false;
    //         } else if (!REGEX_NAME_DEFAULT.test(this.refs.username.getValue())) {
    //             messagesError.errorUsername = 'Special characters not allowed';
    //             isValid = false;
    //         } else if (this.refs.username.getValue().length > 90) {
    //             messagesError.errorUsername = 'The username is too long';
    //             isValid = false;
    //         } else if (this.refs.username.getValue().length < 2) {
    //             messagesError.errorUsername = 'The username is too small';
    //             isValid = false;
    //         }

    //         if (!isValid && !isFocusAssigned) {
    //             isFocusAssigned = true;
    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.username.getDOMNode());
    //             PositionUtil.scrollTo(scrollTop);
    //         }
    //     }

    //     if (onSubmit) {
    //         if (!this.refs.whereKnowUsDetail.getValue()) {
    //             // enter here means the dropdown dont was defined
    //             messagesError.errorWhereKnowUsDetail = '';
    //         } else if (this.refs.whereKnowUsDetail.getValue().length > 200) {
    //             messagesError.errorWhereKnowUsDetail = 'The comment is too long';
    //             isValid = false;
    //         } else {
    //             messagesError.errorWhereKnowUsDetail = '';
    //         }

    //         if (!isValid && !isFocusAssigned) {
    //             isFocusAssigned = true;
    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.whereKnowUsDetail.getDOMNode());
    //             PositionUtil.scrollTo(scrollTop);
    //         }
    //     }

    //     // Guest username validation
    //     if (!isPristineUsernameGuest || onSubmit) {
    //         if (ContentUtils.isEmptyField(this.refs.guestUsername)) {
    //             messagesError.errorUsernameGuest = 'The guest name is required';
    //         } else if (!REGEX_NAME_DEFAULT.test(this.refs.guestUsername.getValue())) {
    //             messagesError.errorUsernameGuest = 'Special characters not allowed';
    //             isValid = false;
    //         } else if (this.refs.guestUsername.getValue().length > 90) {
    //             messagesError.errorUsernameGuest = 'The guest name is too long';
    //             isValid = false;
    //         } else if (this.refs.guestUsername.getValue().length < 2) {
    //             messagesError.errorUsernameGuest = 'The guest name is too small';
    //             isValid = false;
    //         }

    //         if (this.refs.guestUsername.getValue() === this.refs.username.getValue()) {
    //             messagesError.errorUsernameGuest = 'The guest username cannot be the same as the admin username';
    //             messagesError.errorUsername = 'The admin username cannot be the same as the guest username';
    //             isValid = false;
    //         }

    //         if (!isValid && !isFocusAssigned) {
    //             isFocusAssigned = true;
    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.guestUsername.getDOMNode());
    //             PositionUtil.scrollTo(scrollTop);
    //         }
    //     }

    //     if (!isPristinePasswordAdmin || onSubmit) {
    //         // Admin password
    //         if (ContentUtils.isEmptyField(this.refs.password)) {
    //             messagesError.errorPasswordAdmin = 'The admin password is required';
    //             isValid = false;
    //         } else if (this.refs.password.getValue().length < 2) {
    //             messagesError.errorPasswordAdmin = 'The password is too small';
    //             isValid = false;
    //         } else if (this.refs.password.getValue().length > 30) {
    //             messagesError.errorPasswordAdmin = 'The password is too long';
    //             isValid = false;
    //         }
    //         if (!isValid && !isFocusAssigned) {
    //             isFocusAssigned = true;
    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.password.getDOMNode());
    //             PositionUtil.scrollTo(scrollTop);
    //         }
    //     }

    //     if (!isPristinePasswordGuest || onSubmit) {
    //         // Guest password
    //         if (ContentUtils.isEmptyField(this.refs.guestPassword)) {
    //             messagesError.errorPasswordGuest = 'The guest password is required';
    //             isValid = false;
    //         } else if (this.refs.guestPassword.getValue().length < 2) {
    //             messagesError.errorPasswordGuest = 'The password is too small';
    //             isValid = false;
    //         } else if (this.refs.guestPassword.getValue().length > 30) {
    //             messagesError.errorPasswordGuest = 'The password is too long';
    //             isValid = false;
    //         }
    //         if (!isValid && !isFocusAssigned) {
    //             isFocusAssigned = true;
    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.guestPassword.getDOMNode());
    //             PositionUtil.scrollTo(scrollTop);
    //         }
    //     }

    //     if (!isPristineEmail || onSubmit) {
    //         // Email Validation
    //         if (ContentUtils.isEmptyField(this.refs.email)) {
    //             messagesError.errorEmail = 'The email is required';
    //             isValid = false;
    //         } else if (!REGEX_EMAIL.test(this.refs.email.getValue())) {
    //             messagesError.errorEmail = 'The email format is not valid';
    //             isValid = false;
    //         } else if (this.refs.email.getValue().length <= 4) {
    //             messagesError.errorEmail = 'The email format is too small';
    //             isValid = false;
    //         } else if (this.refs.email.getValue().length > 90) {
    //             messagesError.errorEmail = 'The email is too long';
    //             isValid = false;
    //         }

    //         if (!isValid && !isFocusAssigned) {
    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.email.getDOMNode());
    //             PositionUtil.scrollTo(scrollTop);
    //         }
    //     }

    //     this.setState(messagesError);

    //     return isValid;
    // },

    onBlurInput(target) {
        this.setState(
            {
                [_.get(target.target.attributes['data-input-name'], 'value')]: false
            },
            () => {
                this.isValidForm(false);
            });
    },

    render() {
        return (
            React.createElement("div", {id: "page-login", className: "signup-page-container"}, 
                React.createElement("div", {
                    className: "text-center"}, 
                    React.createElement("div", {className: "box"}, 
                        React.createElement("div", {className: "box-content"}, 

                            React.createElement("div", {className: "text-center"}, 
                                React.createElement("img", {style: {height: '80px', marginTop: '50px'}, src: "/assets/images/logo-small.png"}), 

                                React.createElement("h3", {className: "page-header light"}, t('sign_up_welcome_title'))
                            ), 

                            React.createElement("div", null, 
                                React.createElement("h4", {className: "page-header light"}, "Sign up with an account for free!")
                            ), 

                            React.createElement("div", {className: "form-group"}, 
                                React.createElement(TextField, {
                                    className: "full-width", 
                                    ref: "applicant", 
                                    "data-input-name": "isPristineApplicantName", 
                                    hintText: t('sign_up_placeholder_applicant'), 
                                    defaultValue: "", 
                                    errorText: this.state.errorApplicantName, 
                                    onBlur: this.onBlurInput, 
                                    floatingLabelText: t('sign_up_label_applicant')})
                            ), 

                            React.createElement("div", {className: "form-group from-group-long-text"}, 
                                React.createElement(TextField, {
                                    className: "full-width", 
                                    ref: "email", 
                                    "data-input-name": "isPristineEmail", 
                                    hintText: t('sign_up_placeholder_email'), 
                                    errorText: this.state.errorEmail, 
                                    defaultValue: "", 
                                    onBlur: this.onBlurInput, 
                                    floatingLabelText: t('sign_up_label_email')})
                            ), 

                            React.createElement("div", {className: "form-group from-group-long-text"}, 
                                React.createElement(TextField, {
                                    className: "full-width", 
                                    ref: "username", 
                                    "data-input-name": "isPristineUsername", 
                                    hintText: t('sign_up_placeholder_username'), 
                                    defaultValue: "", 
                                    errorText: this.state.errorUsername, 
                                    onBlur: this.onBlurInput, 
                                    floatingLabelText: t('sign_up_admin_username')})
                            ), 

                            React.createElement("div", {className: "form-group from-group-long-text"}, 
                                React.createElement(TextField, {
                                    className: "full-width", 
                                    type: "password", 
                                    ref: "password", 
                                    "data-input-name": "isPristinePasswordAdmin", 
                                    hintText: t('sign_up_label_password'), 
                                    errorText: this.state.errorPasswordAdmin, 
                                    defaultValue: "", 
                                    onBlur: this.onBlurInput, 
                                    floatingLabelText: t('sign_up_label_password')})
                            ), 

                            /* <div className="form-group from-group-long-text">
                                <TextField
                                    className="full-width"
                                    ref="guestUsername"
                                    hintText={t('sign_up_placeholder_guest')}
                                    data-input-name="isPristineUsernameGuest"
                                    errorText={this.state.errorUsernameGuest}
                                    defaultValue=""
                                    onBlur={this.onBlurInput}
                                    floatingLabelText={t('sign_up_label_guest')}/>
                            </div>

                            <div className="form-group from-group-long-text">
                                <TextField
                                    className="full-width"
                                    type="password"
                                    ref="guestPassword"
                                    hintText={t('sign_up_placeholder_guest_password')}
                                    data-input-name="isPristinePasswordGuest"
                                    errorText={this.state.errorPasswordGuest}
                                    defaultValue=""
                                    onBlur={this.onBlurInput}
                                    floatingLabelText={t('sign_up_label_guest_password')}/>
                            </div>*/
                            React.createElement("div", {className: "singup-page-button text-center"}, 
                                React.createElement(RaisedButton, {className: "BPButton", label: "Sign Up", primary: true, onClick: this.handleSubmit})
                            ), 
                            React.createElement("hr", null), 
                            React.createElement("div", {className: "text-right", style: {marginBottom: '30px'}}, 
                                React.createElement(Link, {to: "login", className: "txt-default"}, t('sign_up_label_already_have_an_account'))
                            ), 
                            this.state.successfulSignup && React.createElement("div", {className: "text-right", style: {marginBottom: '30px'}}, 
                                "Your account has been created. Taking you to BrewPlanner! Please check your email to confirm your account."
                            )

                        )
                    )
                )
            )
        );
    },

    _getEmptyModelForm(defaultValue) {
        return {
            errorApplicantName: defaultValue,
            errorEmail: defaultValue,
            errorUsername: defaultValue,
            errorPasswordAdmin: defaultValue,
            errorUsernameGuest: defaultValue,
            errorPasswordGuest: defaultValue,

            isPristineApplicantName: true,
            isPristineEmail: true,
            isPristineUsername: true,
            isPristinePasswordAdmin: true,
            isPristineUsernameGuest: true,
            isPristinePasswordGuest: true
        };
    }
});

function isValidUsername(inputValue) {
    return (inputValue || '').match(/\s|[A-Z]/) === null;
}


module.exports = Signup;



/** WEBPACK FOOTER **
 ** ./src/views/Signup/Signup.jsx
 **/